<!-- grid-filter.component.html -->
<form [formGroup]="form" class="grid-filter-form" [attr.data-layout]="layout">
  <div class="grid-filter-container m-2" [class.vertical]="layout === 'vertical'">
    <!-- Dynamic Filter Fields -->
    <ng-container *ngFor="let field of fields">
      <div [ngClass]="getGridClass(field)" [ngStyle]="getFieldWidth(field)">
        <ng-container [ngSwitch]="field.controlType">
          <!-- Input Field -->
          <app-input
            *ngSwitchCase="'input'"
            [formControlName]="field.formControlName"
            [config]="field.config"
            [validation]="field.validation ?? {}"
            (onChange)="onFieldValueChange(field, $event)"
          >
          </app-input>

          <!-- Select/Dropdown Field -->
          <app-select
            *ngSwitchCase="'select'"
            [formControlName]="field.formControlName"
            [config]="field.config"
            (valueChange)="onFieldValueChange(field, $event)"
          >
          </app-select>

          <!-- Date Range Field -->
          <div *ngSwitchCase="'daterange'" class="daterange-wrapper">
            <div class="d-flex gap-3 daterange-inputs">
              <app-datepicker
                [formControlName]="field.formControlName + 'Start'"
                [config]="field.config"
                (valueChange)="onFieldValueChange(field, $event)"
              ></app-datepicker>

              <app-datepicker
                [formControlName]="field.formControlName + 'End'"
                [config]="field.config"
                (valueChange)="onFieldValueChange(field, $event)"
              ></app-datepicker>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>

    <!-- Clear All Filters Button - Inline with filters -->
    <div class="filter-field filter-actions" *ngIf="showClearButton && hasActiveFilters">
      <button
        type="button"
        kendoButton
        fillMode="outline"
        themeColor="base"
        size="medium"
        (click)="clearAllFilters()"
        [disabled]="disabled"
        class="clear-filters-btn"
      >
        <span class="k-icon k-i-filter-clear"></span>
        <span *ngIf="showClearButtonText">Clear Filters</span>
      </button>
    </div>
  </div>
</form>
